import { request } from './client';
import type {
  FreeIntakeInput,
  FreeIntakeResult,
  IntakePending,
  IntakeReceiveInput,
  IntakeReceiveResult,
  PriceIntakeInput,
  PriceIntakeResult,
  ReceiptDiffDecision,
  ReceiptDiffDecisionResult,
  ReceiptDiffItem,
  UnpricedIntake,
} from '@kassa/shared';

export const intakeApi = {
  intakePending: () => request<IntakePending[]>('GET', '/api/intake/pending'),
  intakeReceive: (alsId: string, body: IntakeReceiveInput) =>
    request<IntakeReceiveResult>('POST', `/api/intake/${encodeURIComponent(alsId)}/receive`, body),
  intakeFree: (body: FreeIntakeInput) => request<FreeIntakeResult>('POST', '/api/intake/free', body),
  intakeUnpriced: () => request<UnpricedIntake[]>('GET', '/api/intake/unpriced'),
  intakePrice: (qebId: string, body: PriceIntakeInput) =>
    request<PriceIntakeResult>('POST', `/api/intake/${encodeURIComponent(qebId)}/price`, body),
  intakeDiffs: () => request<ReceiptDiffItem[]>('GET', '/api/intake/diffs'),
  intakeDecide: (diffId: string, decision: ReceiptDiffDecision, note: string | null = null) =>
    request<ReceiptDiffDecisionResult>('POST', `/api/intake/diffs/${encodeURIComponent(diffId)}/decide`, { decision, note }),
};
